import Swiper from 'swiper';

let swiperMenuHome = {
    init() {

        var swiper = new Swiper('.swiper-container.swiper-menu-home', {
            loop: true,
            autoplay: {
                delay: 3000,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}

export default swiperMenuHome;
